// src/enums/indianStates.js

export const States = {
  Punjab: "Punjab",
  Haryana: "Haryana",
  "Uttar Pradesh": "Uttar Pradesh",
  Rajasthan: "Rajasthan",
  // Add other states as needed
};
